export default __webpack_public_path__ + "static/media/CUPS.a81d0958.png";